import * as React from 'react';
import {Link, Avatar, Button, Container, TextField, Typography, IconButton, InputAdornment} from '@mui/material';
import logo from '../../../assets/img/logo.png';
import Cookies from 'universal-cookie';
import Box from "elements/Box";
import { ProjectConfig } from 'Global';
import axios from 'axios';
import { useSnackbar, withSnackbar } from 'notistack';
import LoadingButton from '@mui/lab/LoadingButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
const cookies = new Cookies();

export default withSnackbar(
  function SignIn() {

  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */

  const [loading, setLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  /*================================================
  SIGN IN (SUBMIT)
  ================================================*/
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    setLoading(true);
      const loginData = new URLSearchParams();
      loginData.append("request", "sign_in_admin");
      loginData.append("email", String(data.get("email") || ""));
      loginData.append("password", String(data.get("password") || ""));

      axios
        .post(ProjectConfig.api_url, loginData, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          console.log(response.data);
          
          if(response.data.status === "success"){
            
            enqueueSnackbar(response.data.message, { variant: 'success' });
            const user_data = response.data.user_data;
            console.log(user_data);

            /*================================================
            SET COOKIES
            ================================================*/
            cookies.set('ltkn', user_data.ltkn, { path: '/', maxAge: (86400 * 365) });
            cookies.set('user_id', user_data.user_id, { path: '/', maxAge: (86400 * 365) });
            cookies.set('user_name', user_data.user_name, { path: '/', maxAge: (86400 * 365) });
            cookies.set('role_id', user_data.role_id, { path: '/', maxAge: (86400 * 365) });
            /*================================================
            ================================================*/

            localStorage.setItem('user_id', String(user_data.user_id || ''));
            localStorage.setItem('user_name', String(user_data.user_name || ''));
            if (user_data.image && user_data.image !== 'undefined' && user_data.image !== 'null') {
              localStorage.setItem('user_image', String(user_data.image));
            } else {
              localStorage.removeItem('user_image');
            }
            localStorage.setItem('role_id', String(user_data.role_id || ''));


            window.location.reload();
          }
          else
          {
            enqueueSnackbar(response.data.message, { variant: 'error' });
            
          }
          setLoading(false);
         
        })
        .catch((err) => {
          console.log(err.data);
        });

    
  };
  /*================================================
  ================================================*/

  return (
    <div className='loginContainer'>
      <Box id='loginBox'>
        <img className='loginLogo' src={logo}></img>

        <p>Enter your email address and password to access your account.</p>
        <form onSubmit={handleSubmit} className='form'>
          <TextField
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            type="text"
            autoComplete="email"
            autoFocus
          />
          <TextField
            required
            fullWidth
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            id="password"
            autoComplete="current-password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <LoadingButton
            size="small"
            type="submit"
            loading={loading}
            fullWidth
            variant="contained"
            sx={{ fontSize: '13px', padding: '10px 0px'}}
          >
            Sign In
          </LoadingButton>

          <Link href="#" variant="body2">
            Forgot password?
          </Link>
        </form>
      </Box>
    </div>
  );
}
);
